module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Reserve vs Paid Comparison",
      "set-position": "relative",
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-reserving p-compare-reserve u-margin-bottom-40",
    attrs: {
      "id": "app"
    }
  }, [_c('claims-dashboard-icons'), _vm._v(" "), _c('p', {
    staticClass: "u-margin-bottom-30"
  }, [_vm._v("\n            Compare the accuracy of your initial or final reserves against paid\n            settlements\n        ")]), _vm._v(" "), _c('compare-form'), _vm._v(" "), (_vm.calculating) ? _c('div', {
    staticClass: "a-loader--results"
  }) : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin"
  }, [_c('div', {
    staticClass: "u-full-width"
  }, [_c('range-chart-container')], 1)]) : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('slider') : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('results-table') : _vm._e(), _vm._v(" "), (_vm.claims.length && !_vm.calculating) ? _c('div', {
    staticClass: "p-compare-reserve__charts"
  }, [_c('div', {
    staticClass: "u-margin-bottom-30"
  }, [_c('difference-chart')], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center"
  }, [(_vm.claims.length && !_vm.calculating) ? _c('button', {
    staticClass: "a-button a-button--small u-margin-top-10",
    on: {
      "click": function($event) {
        _vm.showClaimTable = !_vm.showClaimTable
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.showClaimTable ? 'Hide' : 'Show') + " Table Of Claims\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.claims.length && _vm.showClaimTable) ? _c('claim-table') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-margin-bottom-40"
  }, [_c('fee-earner-chart')], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-696f2e5b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/compare/CompareValues.vue
// module id = 1729
// module chunks = 0